export class TestPlace {
    constructor(
        public id: string,
        public name: string,
        public shortDescription: string,
        public description: string,
        public backgroundImage: string,
        public siteUrl: string,
    ) {
    }
}

export const getTestPlaces: TestPlace[] = [
    {
        id: '1',
        name: 'Cone',
        shortDescription: 'home.ideas_place.cone.title',
        description: 'home.ideas_place.cone.text',
        backgroundImage: require('../assets/images/how-it-works/bg-cone.jpg'),
        siteUrl: 'http://conebr.com/',
    },
    {
        id: '2',
        name: 'GZero',
        shortDescription: 'home.ideas_place.gzero.title',
        description: 'home.ideas_place.gzero.text',
        backgroundImage: require('../assets/images/how-it-works/bg-gzero.jpg'),
        siteUrl: '/',
    },
    {
        id: '3',
        name: 'Convida',
        shortDescription: 'home.ideas_place.convida.title',
        description: 'home.ideas_place.convida.text',
        backgroundImage: require('../assets/images/how-it-works/bg-convida.jpg'),
        siteUrl: 'http://conebr.com/convida/',
    },
];
